/**
 * BSUID Helper Utilities
 * Handles normalisation and display logic for WhatsApp Business-Scoped User IDs.
 */

/**
 * Normalises a raw BSUID value from the API or Pusher event.
 * - Returns trimmed string if valid
 * - Returns null for null/undefined/non-string values
 *
 * @param {string|null|undefined} rawBsuid
 * @returns {string|null}
 */
export function normaliseBsuid(rawBsuid) {
  if (rawBsuid == null || typeof rawBsuid !== 'string') {
    return null;
  }
  return rawBsuid.trim();
}

/**
 * Determines whether a BSUID value should be displayed.
 * Returns true if the value is a non-empty, non-whitespace string.
 *
 * @param {string|null|undefined} bsuid
 * @returns {boolean}
 */
export function isBsuidDisplayable(bsuid) {
  return typeof bsuid === 'string' && bsuid.trim().length > 0;
}
